<ng-container *ngIf="display$ | async as d; else defaultTimer">
	<div class="flex flex-col items-center justify-center">
		<span class="record-toolbar-counter__wrap">
			<span class="record-toolbar-counter__hours">{{ d.hours }}</span>
			<span
				aria-hidden="true"
				class="record-toolbar-counter__sep"
				>:</span
			>
			<span class="record-toolbar-counter__minutes">{{ d.minutes }}</span>
		</span>
		<span class="text-sm text-gray-500"> {{ start | date:'HH:mm' }}</span>
	</div>
</ng-container>
<ng-template #defaultTimer> <div>00:00</div> </ng-template>
